import React from 'react'
import { StyleSheet } from 'react-native'
import { Text } from 'zens-storybook'
import { useFloor } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props {
  companyId: number
  floorId: number
}
const FloorCell = (props: Props) => {
  const { companyId, floorId } = props
  const floor = useFloor({ companyId, floorId })

  return <Text style={styles.container}>{floor.data?.displayName}</Text>
}

export default FloorCell
